import {cn} from "@adleritech/web-ui/utils";
import {forwardRef, type HTMLAttributes, type ReactNode} from "react";
import {ScrollFadeWrapper} from "./ScrollFadeWrapper";
import styles from "./Sheet.module.css";

type SheetHeaderProps = HTMLAttributes<HTMLHeadingElement> & {
    children?: ReactNode;
};

function SheetHeader({children, className, ...props}: SheetHeaderProps) {
    return (
        <h1 className={cn(styles.header, className)} {...props}>
            {children}
        </h1>
    );
}

type SheetBodyProps = HTMLAttributes<HTMLDivElement> & {
    children?: ReactNode;
};

function SheetBody({children, className, ...props}: SheetBodyProps) {
    return (
        <ScrollFadeWrapper className={cn(styles.body, className)} {...props}>
            {children}
        </ScrollFadeWrapper>
    );
}

type SheetButtonsProps = HTMLAttributes<HTMLDivElement> & {
    children?: ReactNode;
};

function SheetButtons({children, className, ...props}: SheetButtonsProps) {
    return (
        <div className={cn(styles.buttons, className)} {...props}>
            {children}
        </div>
    );
}

type SheetTextProps = HTMLAttributes<HTMLDivElement> & {
    children?: ReactNode;
};

function SheetText({children, className, ...props}: SheetTextProps) {
    return (
        <div className={cn(styles.text, className)} {...props}>
            {children}
        </div>
    );
}

type SheetProps = HTMLAttributes<HTMLDivElement> & {
    showLoader?: boolean;
    children?: ReactNode;
};

const SheetRoot = forwardRef<HTMLDivElement, SheetProps>(function Sheet(
    {className, showLoader, children, ...props},
    ref
) {
    return (
        <div className={cn(styles.sheet, className)} ref={ref} {...props}>
            {showLoader && <div className={styles.loader} />}
            {children}
        </div>
    );
});

export const Sheet = Object.assign(SheetRoot, {
    Header: SheetHeader,
    Body: SheetBody,
    Buttons: SheetButtons,
    Text: SheetText,
});
